import AuthComponent from "./AuthComponent";
export default AuthComponent